<button
  type="button"
  class="support-panel-handle"
  [class.is-open]="panel.open()"
  [class.is-hidden]="panel.handleHidden()"
  [attr.aria-expanded]="panel.open()"
  [attr.aria-label]="'support.panel.toggle' | transloco"
  (click)="toggle()"
  data-test-id="support-handle"
>
  <i eIcon icon="life-ring"></i>
  @if (badge.total() > 0) {
    <span class="support-panel-badge" data-test-id="support-badge">{{ badge.total() }}</span>
  }
</button>

<aside
  class="support-panel"
  [class.is-open]="panel.open()"
  [inert]="!panel.open()"
  role="complementary"
  aria-labelledby="support-panel-title"
  (keydown.escape)="panel.close()"
>
  <div class="support-panel-header">
    <span class="support-panel-title" id="support-panel-title">{{ 'support.panel.title' | transloco }}</span>
    <button
      eBtn
      size="sm"
      squared
      type="button"
      icon="chevron-right"
      [attr.aria-label]="'support.panel.close' | transloco"
      (click)="toggle()"
      data-test-id="support-close"
    ></button>
  </div>

  <nav class="support-panel-tabs" role="tablist">
    <button
      type="button"
      role="tab"
      class="support-panel-tab"
      id="support-tab-new"
      [class.is-active]="panel.activeTab() === 'new'"
      [attr.aria-selected]="panel.activeTab() === 'new'"
      (click)="selectTab('new')"
      data-test-id="support-tab-new"
    >
      {{ 'support.panel.tabs.new' | transloco }}
    </button>
    <button
      type="button"
      role="tab"
      class="support-panel-tab"
      id="support-tab-mine"
      [class.is-active]="panel.activeTab() === 'mine'"
      [attr.aria-selected]="panel.activeTab() === 'mine'"
      (click)="selectTab('mine')"
      data-test-id="support-tab-mine"
    >
      {{ 'support.panel.tabs.mine' | transloco }}
      @if (badge.mineUnread() > 0) {
        <span class="support-panel-tab-badge">{{ badge.mineUnread() }}</span>
      }
    </button>
    @if (access.canManage()) {
      <button
        type="button"
        role="tab"
        class="support-panel-tab"
        id="support-tab-manage"
        [class.is-active]="panel.activeTab() === 'manage'"
        [attr.aria-selected]="panel.activeTab() === 'manage'"
        (click)="selectTab('manage')"
        data-test-id="support-tab-manage"
      >
        {{ 'support.panel.tabs.manage' | transloco }}
        @if (badge.manageUnread() > 0) {
          <span class="support-panel-tab-badge">{{ badge.manageUnread() }}</span>
        }
      </button>
    }
  </nav>

  <div class="support-panel-body" role="tabpanel" [attr.aria-labelledby]="'support-tab-' + panel.activeTab()">
    @defer (when panel.open()) {
      @if (content(); as contentComponent) {
        <ng-container *ngComponentOutlet="contentComponent" />
      } @else {
        <div class="support-panel-loading" data-test-id="support-loading"></div>
      }
    } @placeholder {
      <div class="support-panel-loading"></div>
    }
  </div>
</aside>
